import { BaBase } from "./ba-base";
import { bonusAiStorage } from "./bonus-ai-storage";

export class BaViewerControl extends BaBase {
    static override webComponentName: string = "ba-viewer-control";
    protected override _templateId: string = "ba-viewer-control"
    get auto (): boolean {
        return this.hasAttribute('auto');
    }
    public get src(): string {
        return bonusAiStorage.srcUrl;
    }
    refresh(): void {
        this.render();
    }
    protected onConnected(): void {
        super.onConnected(); 
        this.on('click', '[data-viewer-action]', (e:Event) => {
            const target = e.target as HTMLElement;
            this.classList.toggle('viewer-opened',target.dataset.viewerAction === 'open');
        });
    }
    protected afterRender(): void {
        super.afterRender();
        if(this.auto) {
            this.classList.toggle('viewer-opened', this.auto);
        }
    }
    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            auto: this.auto,
            src: this.src || null
        };
    }
}